import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9219 8.22461L10.9219 12.2246L14.9219 16.2246"
      stroke="#111111"
      strokeOpacity={0.4}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={24.6719}
      y={23.9746}
      width={23.5}
      height={23.5}
      rx={11.75}
      transform="rotate(-180 24.6719 23.9746)"
      stroke="#111111"
      strokeOpacity={0.4}
      strokeWidth={0.5}
    />
  </svg>
);
export default SVGComponent;
